import { AnyAction, Dispatch, MiddlewareAPI } from '@reduxjs/toolkit';
import { RootState } from 'src/app/store';
import { setRememberMe } from 'src/features/globalSlice';
import {
  localStorageHelper,
  sessionStorageHelper,
  StoragePrefix,
} from 'src/utils/localStorage';

import { loginSuccess, logout, setAllUsers } from '../actions/authActions';
import { setMapFilter } from '../actions/ticketActions';
import { User } from '../models/Auth';
import { MapFilter } from '../models/Ticket';

export const storageMiddleware =
  (store: MiddlewareAPI) =>
  (next: Dispatch<AnyAction>) =>
  (action: AnyAction): void => {
    next(action);

    const storageHelper = localStorageHelper?.get(StoragePrefix.REMEMBER_ME)
      ? localStorageHelper
      : sessionStorageHelper;

    /* Auth actions */
    if (
      action?.type === loginSuccess.type ||
      action?.type === setAllUsers.type
    ) {
      storageHelper.set<User>(
        StoragePrefix.USER,
        (store.getState() as RootState)?.auth?.user
      );
    }
    if (action?.type === logout.toString()) {
      window.localStorage.clear();
      window.sessionStorage.clear();
    }
    if (action?.type === setRememberMe.toString()) {
      localStorageHelper.set<boolean>(
        StoragePrefix.REMEMBER_ME,
        (store.getState() as RootState)?.global?.rememberMe
      );
    }

    /* Ticket actions */
    if (action?.type === setMapFilter.toString()) {
      storageHelper.set<MapFilter>(StoragePrefix.MAP_FILTER, action.payload);
    }
  };
